import { IComboBoxOptionStyles } from 'office-ui-fabric-react';

export const sharedComboBoxOptionStyles: Partial<IComboBoxOptionStyles> = {
    root: {
        selectors: {
            '@media (forced-colors: active)': {
                backgroundColor: 'Canvas',
                color: 'CanvasText',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    rootChecked: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    rootHovered: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    rootFocused: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    rootPressed: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    rootCheckedDisabled: {
        selectors: {
            '@media (forced-colors: active) and (prefers-color-scheme: light)': {
                backgroundColor: 'HighlightText',
                color: 'CanvasText',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
            '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
                backgroundColor: 'CanvasText',
                color: 'Canvas',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    optionText: {
        selectors: {
            '@media (forced-colors: active)': {
                color: 'inherit',
                backgroundColor: 'transparent',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
    optionTextWrapper: {
        selectors: {
            '@media (forced-colors: active)': {
                color: 'inherit',
                opacity: 1,
                forcedColorAdjust: 'none',
            },
        },
    },
};
